import React from 'react';
import styled from 'styled-components';
import ToolTip from '@ertelecom/ui-react/components/tooltip';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';
import crossIcon from '../../assets/img/cross.svg';

const BREAKPOINT = '@media (max-width: 640px)';

const Block = styled.div`
    display: block;
    box-sizing: border-box;
    max-width: 430px;
    position: relative;
    font-family: 'robotoLight', Arial, Helvetica, sans-serif;
    font-size: 14px;
    line-height: 20px;
    padding: 30px;
    ${BREAKPOINT} {
        padding: 20px 15px;
    }
    @media (max-width: 640px) {
        width: 280px;
    }
`;
const CloseIcon = styled.img`
    position: absolute;
    width: 16px;
    height: 16px;
    right: 16px;
    top: 16px;
    cursor: pointer;
`;

const Link = styled.a`
    display: inline-block;
    font-family: 'robotoLight', Arial, Helvetica, sans-serif;
    font-size: 16px;
    cursor: pointer;
    color: ${COLORS.blue};
    transition: all 0.2s ease-in;
    border-bottom: 1px solid;
    @media (min-width: 640px) {
        &:hover {
            color: ${COLORS.red};
        }
    }
`;
const Title = styled(Link)`
    font-family: 'robotoRegular', Arial, Helvetica, sans-serif;
    font-size: 20px;
    line-height: 24px;
    margin-bottom: 10px;
    color: ${COLORS.black};
    border: none;
`;
const ButtonText = styled.div`
    font-family: 'robotoRegular', Arial, Helvetica, sans-serif;
    font-size: 14px;
    color: ${COLORS.darkGrey};
    margin-bottom: 15px;
`;
const GreyText = styled.div`
    font-size: 16px;
    color: ${COLORS.darkGrey};
    margin-top: 15px;
    line-height: 24px;
`;
const ChannelBlock = styled.div`
    margin-bottom: 25px;
    width: 23%;
    margin-right: 2%;
    display: flex;
    flex-wrap: nowrap;
    cursor: pointer;
    @media (max-width: 1280px) {
        display: block;
        width: 25%;
        margin-right: 0;
    }
    @media (max-width: 640px) {
        width: 45%;
    }
`;
const Channel = styled.a`
    font-size: 16px;
    height: 16px;
    align-self: center;
    color: black;
    border-bottom: 1px dotted black;
    transition: color 0.2s ease-in;
    max-width: 90%;
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-decoration: none;

    &:hover {
        @media (min-width: 640px) {
            color: ${COLORS.red};
        }
        border-color: transparent;
    }
    @media (max-width: 1280px) {
        border-bottom: none;
    }
`;
const ChannelLogo = styled.img`
    width: 43px;
    height: 43px;
    margin-right: 10px;
    flex-shrink: 0;
    @media (max-width: 1280px) {
        margin-bottom: 5px;
    }
`;
const LinkWrapper = styled.div`
    display: inline-block;
    white-space: pre;
`;

const HiddenLinks = styled.div`
    display: none;
`;

const BUNDLE_LINK = '/bundles/{alias}';
const PACKAGE_LINK = '{alias}';
const CHANNEL_LINK = '/domru-tv/channel/';

const LinkElem = ({ href, title }) => (
    <Link href={href} target='_blank' rel='noopener noreferrer'>{title}</Link>
);

const RenderLinks = ({ links = [], url, title }) => {
    if (links.length === 0) {
        return null;
    }

    const elements = links.map((link, index) => {
        const href = url.replace('{alias}', link.alias);
        if (index !== links.length - 1) {
            return (
                <LinkWrapper key={link.alias}><LinkElem href={href} title={link.title} />, </LinkWrapper>
            );
        }
        return <LinkElem key={link.alias} href={href} title={link.title} />;
    });

    return (
        <React.Fragment>
            <GreyText>Канал входит в {title}:</GreyText>
            {elements}
        </React.Fragment>
    );
};

export default class ChannelTooltip extends React.Component {
    state = {
        showPopup: false
    };

    channelRef = React.createRef();

    open = (event) => {
        event.stopPropagation();
        this.setState({
            showPopup: true
        });
    };

    close = () => {
        if (this.props.group && !this.state.showPopup) {
 return;
}

        this.setState({
            showPopup: false
        });
    };

    relocate = () => {
        this.forceUpdate();
    };

    componentDidMount() {
        window.addEventListener('resize', this.relocate);
        document.body.addEventListener('click', this.close);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.relocate);
        document.body.removeEventListener('click', this.close);
    }

    render() {
        const { channel = {}, className, group } = this.props;
        const { showPopup } = this.state;
        const currChannelRef = this.channelRef?.current;
        return (
            <React.Fragment>
                <ChannelBlock className={className} data-test='block-of-channel' ref={this.channelRef} onClick={this.open}>
                    <ChannelLogo src={channel.logo} />
                    <Channel href={CHANNEL_LINK + channel.id} onClick={(e) => e.preventDefault()}>{channel.title}</Channel>

                    <HiddenLinks>
                        <RenderLinks title='тарифы' links={channel.salePackages} url={BUNDLE_LINK} />
                        <RenderLinks title='пакеты' links={channel.channelPackages} url={PACKAGE_LINK} />
                    </HiddenLinks>
                </ChannelBlock>
                {
                    currChannelRef && <ToolTip group={group} active={showPopup} parent={currChannelRef} position='top' arrow='center' useHover={false} tooltipTimeout={100}>
                        <Block data-test='channel-tooltip'>
                            <CloseIcon data-test='icon-close-channel-tooltip' src={crossIcon} onClick={this.close} />
                            <Title data-test='channel-tooltip-title' href={CHANNEL_LINK + channel.id} target='_blank'>{channel.title}</Title>
                            <ButtonText>{channel.button}</ButtonText>

                            <div data-test='channel-tooltip-description' dangerouslySetInnerHTML={{ __html: channel.description }} />

                            <RenderLinks title='тарифы' links={channel.salePackages} url={BUNDLE_LINK} />
                            <RenderLinks title='пакеты' links={channel.channelPackages} url={PACKAGE_LINK} />
                        </Block>
                    </ToolTip>
                }
            </React.Fragment>
        );
    }
}
